import React from 'react';
// import data
import { heroData } from '../data';
// import motion
import { motion } from "framer-motion";
// import variants
import { fadeIn, staggerContainer } from '../variants';

import HeaderLogo from '../assets/img/hero/gohost_header_1.png';
import ModelB from '../assets/img/model-black.png';

const Hero = React.forwardRef(({scrollToMenu}, ref) => {
  // destructure hero data
  const {pretitle, title, title2, subtitle, btnText} = heroData;

  return (
    <section
  ref={ref}
  className="select-none h-[700px] bg-gradient-to-b from-stone-800 to-[#ead05a] bg-cover bg-right-bottom"
>
      <div className='container mx-auto bg-pink-200/0 min-h-[900px] flex justify-center items-center '>
        <motion.div 
        variants={staggerContainer(0.1,1)}
        initial='hidden'
        whileInView={'show'}
        className='text-center flex flex-col items-center'>
          {/* pretitle */}
          <motion.div
          variants={fadeIn('down', 'tween', 0.1,1.1)} 
          style={{ textShadow: '0 0 18px #ead05a, 0 0 40px #ead05a' }}
          className='text-stone-700 text-[30px] lg:text-[40px] xl:text-[40px] h2 lg:font-medium mb-2'>Have a Seat With

          </motion.div>
          {/* title */}

          <motion.img
          variants={fadeIn('down', 'tween', 0.2, 1.1)}
          src={HeaderLogo}
          alt="GoHost Logo"
          className="lg:w-[400px] w-[320px] my-6 drop-shadow-[0_1.2px_4.2px_rgba(39,39,42,1)]"
        />
                  {/* model */}

                  <motion.img
          variants={fadeIn('down', 'tween', 0.3, 1.1)}
          src={ModelB}
          alt="GoHost Logo"
          className="lg:w-[90px] w-[80px] my-4 "
        />

          {/* <motion.h1 
  variants={fadeIn('down', 'tween', 0.2, 1.1)} 
  className='text-red-800 drop-shadow-[0_1.2px_4.2px_rgba(215,200,169,1)] lg:text-[80px] xl:text-[95px] h1 mb-5'>
  Go<span className="text-stone-800">Host</span>
</motion.h1> */}
          {/* subtitle */}
          <motion.p 
          variants={fadeIn('down', 'tween', 0.4,1.1)} 
          style={{ textShadow: '0 0 18px #ead05a, 0 0 40px #ead05a' }}
          className=' text-[18px] text-stone-700 max-w-[400px] mb-8 lg:text-[20px] '>A New Standard of Operational and Visual Excellence for Restaurant POS and Web Design
          </motion.p>
          {/* button */}
          {/* <motion.div
          variants={fadeIn('down', 'tween', 0.4,1.1)} >
          <button className='btn' onClick={scrollToMenu}>{btnText}</button>
          </motion.div> */}
        </motion.div>
      </div>
    </section>
  );
});

export default Hero;
